import SimpleAutocompleteFactory from "components/Autocomplete/SimpleAutocompleteFactory"
import { TransactionFilterComplexityValueEnum } from "services/api/openapi"

export const ComplexityFilter = SimpleAutocompleteFactory<TransactionFilterComplexityValueEnum>({
  simple: "Simple Transactions",
  complex: "Complex Transactions",
})

export default ComplexityFilter
